import {useEffect} from 'react'
import {HashLink} from 'react-router-hash-link'

import {APP_ROUTES} from '../../../routes/routes'

const BondsSectionHeader = () => {

  const changeSubmenuStyleBasedOnScroll = ()=> {
    const header = document.querySelector('#header')
    const subMenu = document.querySelector('.nav-header')

    if (window.innerWidth > 990) {
      const currentScrollPos = window.scrollY

      if (currentScrollPos> 90) {
        header.classList.add('hidden')
        subMenu.classList.add('fixed')
      } else {
        header.classList.remove('hidden')
        subMenu.classList.remove('fixed')
      }
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', changeSubmenuStyleBasedOnScroll)

    return () => window.removeEventListener('scroll', changeSubmenuStyleBasedOnScroll)
  }, [])

  const links = [
    {id: 'bonds-overview', label: 'Overview'},
    {id: 'bonds-highlights', label: 'Key highlights'},
    {id: 'bonds-reports', label: 'Reports'},
    {id: 'bonds-instruments', label: 'Financing instruments'},
    {id: 'bonds-contact', label: 'Contact form'}
  ]

  return (
    <div className="nav-header">
      <div className="nav-header-container">
        <ul>
          {links.map(({id, label}) => {
            return (
              <li key={`bonds-sub-menu-${id}`}>
                <HashLink to={`${APP_ROUTES.BONDS}#${id}`}>{label}</HashLink>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default BondsSectionHeader
